/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\HomePage\PostItDisplay.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Thursday March 14th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday March 14th 2024 4:08:21 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Styles from "Content/HomePage/PostItDisplay.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { useNavigate } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { useUserContext } from "Hooks/useUserContext";

function PostItDisplay() {
    const navigate = useNavigate();
    const { Role } = useUserContext();

    return (
        <div className={`${Styles.holder} p-3`}>
            {/* <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathOffers.path)}>
                <h3>{translator.decode("stats.offers")} </h3>
            </div> */}
            <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathStats.path)}>
                <h3>{translator.decode("dynamic.stats")} </h3>
            </div>
            <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathCompanies.path)}>
                <h3>{translator.decode("dynamic.companies")} </h3>
            </div>
            <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathMyCompany.path)}>
                <h3>{translator.decode("users.myCompany")} </h3>
            </div>
            <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathMyUser.path)}>
                <h3>{translator.decode("users.myUsers")} </h3>
            </div>
            {Role === "ADMIN" &&
            <>
                <div className={`${Styles.blue} ${Styles.colorAdmin}`} onClick={() => navigate(RouterPathResolver.pathMyCommercial.path)}>
                    <h3>{translator.decode("users.myCommercials")} </h3>
                </div>
                <div className={`${Styles.blue} ${Styles.colorAdmin}`} onClick={() => navigate(RouterPathResolver.pathEditMessage.path)}>
                    <h3>{translator.decode("dynamic.editMessage")} </h3>
                </div>
                <div className={`${Styles.blue} ${Styles.colorAdmin}`} onClick={() => navigate(RouterPathResolver.pathSendMessage.path)}>
                    <h3>{translator.decode("dynamic.sendMessage")} </h3>
                </div>
                <div className={`${Styles.blue} ${Styles.colorAdmin}`} onClick={() => navigate(RouterPathResolver.pathVisuals.path)}>
                    <h3>{translator.decode("dynamic.visuals")} </h3>
                </div>
            </>
            }
            {/* <div className={`${Styles.blue}`} onClick={() => navigate(RouterPathResolver.pathParks.path)}>
                <h3>{translator.decode("dynamic.parks")} </h3>
            </div> */}
        </div>
    )
}

export default PostItDisplay;
